module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/views/companies/company-match/company-match.component.css
// module id = ./src/app/views/companies/company-match/company-match.component.css
// module chunks = main